module.exports = __webpack_public_path__ + "img/justin-c-key.b55108f5.png";